import React from 'react';
import SingleTestimonial from './SingleTestimonial';
import {testimonials} from '../../data/testimonials';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import {Carousel} from 'react-responsive-carousel';

const Testimonials = () => {
	return (
		<section id="testimonials">
			<div className="container container--md">
				<div className="slider-wrapper">
					<Carousel showThumbs={false} autoPlay={false}>
						{testimonials.map((t, index) => (
							<SingleTestimonial testimonial={t} key={index} />
						))}
					</Carousel>
				</div>
			</div>
		</section>
	);
};

export default Testimonials;
